import {
  P0_SSH_ROLE_BASE_NAME,
  P0_SSH_ROLE_PERMISSIONS,
  P0_SSH_SUDO_ROLE_BASE_NAME,
  toP0ManagementRoleName,
} from "@p0security/shared/integrations/resources/azure/permissions";
import { toParentId } from "@p0security/shared/integrations/resources/ssh/util";
import Paragraph from "antd/lib/typography/Paragraph";

export const azureSudoInstructions = (id: string, azureClientId?: string) => {
  const subscriptionId = toParentId(id);
  const roleName = toP0ManagementRoleName(
    P0_SSH_SUDO_ROLE_BASE_NAME,
    subscriptionId
  );
  const jsonFileName = "p0-virtual-machine-admin-management-role.json";

  return {
    help: (
      <Paragraph>
        Create a custom role for P0 to grant sudo access to Azure Machines.
      </Paragraph>
    ),
    commands: {
      shell: [
        {
          header: "Target the subscription P0 is being installed on",
          command: `az account set --subscription ${subscriptionId}`,
        },
        {
          header: `Create a ${P0_SSH_SUDO_ROLE_BASE_NAME} Role`,
          command: `# Create a JSON file for the role definition
cat > ${jsonFileName} << 'EOF'
  {
    "Name": "${roleName}",
    "IsCustom": true,
    "Description": "Custom role for ${P0_SSH_SUDO_ROLE_BASE_NAME}",
    "Actions": ${JSON.stringify(P0_SSH_ROLE_PERMISSIONS, null, 2)},
    "NotActions": [],
    "AssignableScopes": [
      "/subscriptions/${subscriptionId}"
    ],
    "DataActions": [
      "Microsoft.Compute/virtualMachines/login/action",
      "Microsoft.Compute/virtualMachines/loginAsAdmin/action"
    ]
  }
EOF

  # Create the custom role
az role definition create --role-definition ${jsonFileName}`,
        },
        {
          header: `Create role assignment of service principal to new ${P0_SSH_SUDO_ROLE_BASE_NAME} Role in the current subscription`,
          command: azureClientId
            ? `az role assignment create --assignee ${azureClientId} --role "${roleName}" --scope /subscriptions/${subscriptionId}`
            : "Unable to find client ID from P0 Azure App Registration.  Please re-run the Azure App installation.",
        },
      ],
    },
  };
};

export const azureInstructions = (id: string, azureClientId?: string) => {
  const subscriptionId = toParentId(id);

  const roleName = toP0ManagementRoleName(
    P0_SSH_ROLE_BASE_NAME,
    subscriptionId
  );
  const jsonFileName = "p0-virtual-machine-management-role.json";

  return {
    help: (
      <Paragraph>
        Create a custom role for P0 to grant SSH access to Azure Virtual
        Machines.
      </Paragraph>
    ),
    commands: {
      shell: [
        {
          header: "Target the subscription P0 is being installed on",
          command: `az account set --subscription ${subscriptionId}`,
        },
        {
          header: `Create a ${P0_SSH_ROLE_BASE_NAME} Role`,
          command: `# Create a JSON file for the role definition
cat > ${jsonFileName} << 'EOF'
  {
    "Name": "${roleName}",
    "IsCustom": true,
    "Description": "Custom role for ${P0_SSH_ROLE_BASE_NAME}",
    "Actions": ${JSON.stringify(P0_SSH_ROLE_PERMISSIONS, null, 2)},
    "NotActions": [],
    "AssignableScopes": [
      "/subscriptions/${subscriptionId}"
    ],
    "DataActions": [
      "Microsoft.Compute/virtualMachines/login/action"
    ]
  }
EOF

  # Create the custom role
az role definition create --role-definition ${jsonFileName}`,
        },
        {
          header: `Create role assignment of service principal to new ${P0_SSH_ROLE_BASE_NAME} Role in the current subscription`,
          command: azureClientId
            ? `az role assignment create --assignee ${azureClientId} --role "${roleName}" --scope /subscriptions/${subscriptionId}`
            : "Unable to find client ID from P0 Azure App Registration.  Please re-run the Azure App installation.",
        },
      ],
    },
  };
};
